function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "_\\u30A4\\u30E4\\u30FC_1-2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M70.36,23.07c-5.64,0-9.84,2.33-12.24,4.13V9.37l-9.95-4.31v60.7h9.95v-27.35c1.9-2.26,5.89-5.86,11.96-5.86,3.37,0,6.57,1.51,8.56,4.06,1.28,1.59,2.47,3.87,2.47,9.76v19.38h9.95v-18.92c0-7.21-1.31-11.96-4.39-15.85-3.95-5.04-9.9-7.92-16.32-7.92Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 98.16,
  y: 21,
  width: 9.95,
  height: 44.77
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M253.6,20.64c-12.86,0-22.56,9.78-22.56,22.75s9.7,22.74,22.56,22.74,22.56-9.78,22.56-22.74-9.7-22.75-22.56-22.75Zm0,37.13c-7.83,0-13.74-6.19-13.74-14.39s5.91-14.39,13.74-14.39,13.74,6.19,13.74,14.39-5.91,14.39-13.74,14.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M138.29,20.64c-7.79,0-12.28,3.74-14.15,5.8v-5.44h-8.86l-.02,52.43,9.82,4.25,.02-16.52c1.8,1.79,6.05,4.94,13.72,4.94,13.57,0,21.68-11.32,21.68-22.26,0-6.07-1.97-11.73-5.56-15.93-4.04-4.75-9.8-7.26-16.65-7.26Zm-.53,8.87c8.32,0,13.48,7.2,13.48,13.87s-5.07,14.39-13.25,14.39c-7.35,0-13.33-6.52-13.33-14.54,0-7.57,5.88-13.72,13.1-13.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M188.29,20.64c-7.79,0-12.28,3.74-14.15,5.8v-5.44h-8.86l-.02,52.43,9.82,4.25,.02-16.52c1.8,1.79,6.05,4.94,13.72,4.94,13.57,0,21.68-11.32,21.68-22.26,0-6.07-1.97-11.73-5.56-15.93-4.04-4.75-9.8-7.26-16.65-7.26Zm-.53,8.87c8.32,0,13.48,7.2,13.48,13.87s-5.07,14.39-13.25,14.39c-7.35,0-13.33-6.52-13.33-14.54,0-7.57,5.88-13.72,13.1-13.72Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M34.26,33.19c-2.79-1.86-6.18-3.3-9.46-4.69-6.48-2.75-12.6-5.34-12.6-10.67s5.27-8.44,10.49-8.44c6.67,0,12.04,4.18,12.04,4.18l3.59-8.29S31.65,0,22.31,0C11.12,0,2.35,7.71,2.35,17.55c0,6.05,2.48,11.04,8.13,14.77,2.74,1.8,10.66,5.28,11.41,5.61,6,2.63,10.95,4.91,11,10.04,0,5.4-4.66,9.05-10.95,9.05-3.18,0-6.82-1.09-9.78-2.94-2.64-1.37-7.04-6.25-8.07-7.49L0,56c5.83,6.94,13.54,10.41,22.41,10.41,12.03,0,20.43-7.87,20.43-19.13,0-5.91-2.57-10.13-8.58-14.09Z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 103.14,
  cy: 10.02,
  r: 6.3
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 215.76,
  y: 21,
  width: 9.95,
  height: 44.77
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-1",
  cx: 220.73,
  cy: 10.02,
  r: 6.3
})));
var SvgShippioLogoWhite = function SvgShippioLogoWhite(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30A4\\u30E4\\u30FC_2",
    viewBox: "0 0 276.15 77.67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShippioLogoWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shippio-logo-white.1399b74b.svg";
export { ForwardRef as ReactComponent };